import { App } from 'vue';
const _data = {};
const ENV_KEY = 'env';
const BUS_KEY = 'bus';
const USE_USER_STORE_KEY = 'useUserStore';
const REQUEST_KEY = 'request';
const USE_REQUIRED_CONDITION_STORE_KEY = 'useRequiredConditionStore';
const REQUIRED_CONDITION_EVENT_OBJ_KEY = 'required_condition_event_obj';
const GLOBAL_MAP_KEY = 'globMap';
const EVENT_OBJ_KEY = 'event_obj';
const LS_KEY = 'ls';
const SOURCE_STORE_KEY = 'sourceStore';
const USE_PAGE_CONFIG_STORE_KEY = 'usePageConfigStore';
const REMOTE_SELECT_STORE_KEY = 'remoteSelectStore';
const CELL_COMPONENT_MAP_KEY = 'cellComponentMap';
const CELL_FORMAT_EXCEL_VALUE_MAP_KEY = 'cellFormatExcelValueMap';
const USE_APP_STORE_KEY = 'useAppStore';
const MENU_COMPONENTS_KEY = 'menu_components';
const DEBUGE_CODE_COMPONENT_KEY = 'debuge_code_component';
const EXTRA_MENU_ICONS_KEY = 'extraMenuIcons';
const WORKER_HOST_FUNCTIONS_KEY = 'workerHostFunctions';
const INJECT_MENU_STATE_KEY = 'injectMenuState';

export function envInit(env: Record<string, any>) {
  return {
    install(app: App) {
      _data[ENV_KEY] = env;
    },
  };
}
export function busInit(bus: any) {
  return {
    install(app: App) {
      _data[BUS_KEY] = bus;
    },
  };
}
export function useUserStoreInit(useUserStore: any) {
  return {
    install(app: App) {
      _data[USE_USER_STORE_KEY] = useUserStore;
    },
  };
}
export function useAppStoreInit(useAppStore: any) {
  return {
    install(app: App) {
      _data[USE_APP_STORE_KEY] = useAppStore;
    },
  };
}
export function requestInit(request: any) {
  return {
    install(app: App) {
      _data[REQUEST_KEY] = request;
    },
  };
}
export function useRequiredConditionStoreInit(useRequiredConditionStore: any) {
  return {
    install(app: App) {
      _data[USE_REQUIRED_CONDITION_STORE_KEY] = useRequiredConditionStore;
    },
  };
}
export function required_condition_event_objInit(required_condition_event_obj: any) {
  return {
    install(app: App) {
      _data[REQUIRED_CONDITION_EVENT_OBJ_KEY] = required_condition_event_obj;
    },
  };
}
export function globMapInit(globMap: Record<string, any>) {
  return {
    install(app: App) {
      _data[GLOBAL_MAP_KEY] = globMap;
    },
  };
}
export function event_objInit(event_obj: any) {
  return {
    install(app: App) {
      _data[EVENT_OBJ_KEY] = event_obj;
    },
  };
}
export function lsInit(ls: any) {
  return {
    install(app: App) {
      _data[LS_KEY] = ls;
    },
  };
}
export function sourceStoreInit(sourceStore: any) {
  return {
    install(app: App) {
      _data[SOURCE_STORE_KEY] = sourceStore;
    },
  };
}
export function cellComponentMapInit(cellComponentMap: any) {
  return {
    install(app: App) {
      _data[CELL_COMPONENT_MAP_KEY] = cellComponentMap;
    },
  };
}
export function cellFormatExcelValueMapInit(cellFormatExcelValueMap: any) {
  return {
    install(app: App) {
      _data[CELL_FORMAT_EXCEL_VALUE_MAP_KEY] = cellFormatExcelValueMap;
    },
  };
}
export function usePageConfigStoreInit(usePageConfigStore: any) {
  return {
    install(app: App) {
      _data[USE_PAGE_CONFIG_STORE_KEY] = usePageConfigStore;
    },
  };
}
export function remoteSelectStoreInit(remoteSelectStore: any) {
  return {
    install(app: App) {
      _data[REMOTE_SELECT_STORE_KEY] = remoteSelectStore;
    },
  };
}

export function menuComponentsInit(menuComponents: any) {
  return {
    install(app: App) {
      _data[MENU_COMPONENTS_KEY] = menuComponents;
    },
  };
}

export function debugCodeComponentInit(debugCodeComponent: any) {
  return {
    install(app: App) {
      _data[DEBUGE_CODE_COMPONENT_KEY] = debugCodeComponent;
    },
  };
}
export function extraMenuIconsInit(extraMenuIcons: any) {
  return {
    install(app: App) {
      _data[EXTRA_MENU_ICONS_KEY] = extraMenuIcons;
    },
  };
}

export function workerHostFunctionsInit(workerHostFunctions: any) {
  return {
    install(app: App) {
      _data[WORKER_HOST_FUNCTIONS_KEY] = workerHostFunctions;
    },
  };
}
export function injectMenuStateInit(injectMenuState: any) {
  return {
    install(app: App) {
      _data[INJECT_MENU_STATE_KEY] = injectMenuState;
    },
  };
}

export function useAppStore() {
  return _data[USE_APP_STORE_KEY]();
}
export function useEnv() {
  return _data[ENV_KEY] || {};
}

export function useBus() {
  return _data[BUS_KEY] || {};
}
export function useUserStore() {
  return _data[USE_USER_STORE_KEY]();
}
export function useRequest() {
  return _data[REQUEST_KEY];
}
export function useRequiredConditionStore() {
  return _data[USE_REQUIRED_CONDITION_STORE_KEY]();
}

export function required_condition_event_obj() {
  return _data[REQUIRED_CONDITION_EVENT_OBJ_KEY];
}
export function useGlobMap(key: string) {
  return _data[GLOBAL_MAP_KEY]?.[key] || {};
}

export function event_obj() {
  return _data[EVENT_OBJ_KEY];
}
export function ls() {
  return _data[LS_KEY];
}
export function sourceStore() {
  return _data[SOURCE_STORE_KEY];
}
export function usePageConfigStore() {
  return _data[USE_PAGE_CONFIG_STORE_KEY]();
}
export function remoteSelectStore() {
  return _data[REMOTE_SELECT_STORE_KEY];
}
export function useCellComponentMap() {
  return _data[CELL_COMPONENT_MAP_KEY]() || {};
}
export function useCellFormatExcelValueMap() {
  return _data[CELL_FORMAT_EXCEL_VALUE_MAP_KEY]() || {};
}

export function useMenuComponents() {
  return _data[MENU_COMPONENTS_KEY] || [];
}
export function useDebugCodeComponent() {
  return _data[DEBUGE_CODE_COMPONENT_KEY] || null;
}
export function useExtraMenuIcons() {
  return _data[EXTRA_MENU_ICONS_KEY] || [];
}
export function useWorkerHostFunctions() {
  return _data[WORKER_HOST_FUNCTIONS_KEY] || {};
}
export function useInjectMenuState() {
  return _data[INJECT_MENU_STATE_KEY];
}
